import { useCallback, useEffect } from 'react'
import { Action } from 'redux'
import { useAppDispatch } from '../../store/types'

export const useActiveWindow = (
  windowsLength: number,
  activeModalIndex: number | undefined,
  setActiveModalIndexAction: (newIndex: number | undefined) => Action
) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveModalIndexAction(0))
  }, [windowsLength])

  const handleMinimize = useCallback(
    (index: number) => {
      dispatch(
        setActiveModalIndexAction(activeModalIndex === index ? -1 : index)
      )
    },
    [activeModalIndex]
  )

  return { handleMinimize }
}
